var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_446991",
    clipPath: "url(#clip0_2179_2368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4658 18.7422H8.53244C8.09064 18.7422 7.73242 19.1004 7.73242 19.5422C7.73242 19.984 8.09059 20.3422 8.53244 20.3422H15.4658C15.9076 20.3422 16.2658 19.984 16.2658 19.5422C16.2658 19.1004 15.9076 18.7422 15.4658 18.7422Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4658 16.2192H8.53244C8.09064 16.2192 7.73242 16.5774 7.73242 17.0193C7.73242 17.4611 8.09059 17.8193 8.53244 17.8193H15.4658C15.9076 17.8193 16.2658 17.4611 16.2658 17.0193C16.2658 16.5774 15.9076 16.2192 15.4658 16.2192Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.1333 5.6362H19.5879V0.830382C19.5879 0.371816 19.2297 0 18.7879 0H5.21212C4.77033 0 4.41211 0.371767 4.41211 0.830382V5.6362H1.86666C0.837375 5.6362 0 6.50541 0 7.57376V15.9278C0 16.9961 0.837375 17.8653 1.86666 17.8653H4.41225V22.3227C4.41225 22.7813 4.77042 23.1531 5.21227 23.1531H18.7877C19.2295 23.1531 19.5877 22.7813 19.5877 22.3227V17.8653H22.1333C23.1626 17.8653 24 16.9961 24 15.9278V7.57376C24 6.50546 23.1626 5.6362 22.1333 5.6362ZM6.01209 1.66076H17.9879V5.6362H6.01209V1.66076ZM17.9877 21.4923H6.01228C6.01228 21.3301 6.01228 14.8995 6.01228 14.6988H17.9878C17.9877 14.9046 17.9877 21.3363 17.9877 21.4923ZM18.7879 10.5121H16.7515C16.3097 10.5121 15.9515 10.1403 15.9515 9.6817C15.9515 9.22309 16.3096 8.85132 16.7515 8.85132H18.7879C19.2297 8.85132 19.5879 9.22309 19.5879 9.6817C19.5879 10.1403 19.2297 10.5121 18.7879 10.5121Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2179_2368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.76f158b589b54a1efd2d0eebeb51d5ae.svg";
export { ForwardRef as ReactComponent };